<template>
	<div class="container">
		<div class="container-tit en">SAM U APARTMANT TYPE FACTORIES</div>
		<div class="pc-detail--image">
			<img src="../../assets/images/pc/detail/9_1.jpg" alt="" />
			<img src="../../assets/images/pc/detail/9_2.jpg" alt="" />
			<img src="../../assets/images/pc/detail/9_3.jpg" alt="" />
			<img src="../../assets/images/pc/detail/9_4.jpg" alt="" />
			<img src="../../assets/images/pc/detail/9_5.jpg" alt="" />
		</div>
		<div class="pc-detail--text">
			<ul class="left">
				<li class="item">
					<label class="label">LAND SPACE</label>
					1680PY (5553sqm)
				</li>
				<li class="item">
					<label class="label">TOTAL</label>
					1680PY (5553sqm)
				</li>
				<li class="item">
					<label class="label">FLOOR</label>
					B1 – 5F
				</li>
				<li class="item">
					<label class="label">PURPOSE</label>
					Company building
				</li>
				<li class="item">
					<label class="label">PURCHASE DATE</label>
					Dec 2019
				</li>
			</ul>
			<div class="right">
				IT밸리로 지정된 성수동은 MZ세대와 기존 세대가 어우러질 수 있는 새로운 상권의 탄생된 곳으로 Retail, Flagship
				Store 수요가 매우 높은 상황.
				<br /><br />
				Retail, Flagship Store 임대 및 투자 용도로 매입.
			</div>
		</div>
	</div>
	<div class="footer">
		<div class="footer-wrap">
			<div class="footer-logo"></div>
			<div class="footer-info">
				<div class="line">
					<span>대표 : 서치원</span>
					<span>사업자 등록번호 : 395-87-02794</span>
					<span>주소 : 서울특별시 강남구 도산대로26길 20, 1층(논현동, NEWTURN빌딩)</span>
				</div>
				<div class="line">
					<span>대표번호 : 02-6956-2791</span>
					<span>팩스 : 070-4693-5728</span>
				</div>
			</div>
			<div class="footer-copy">
				개인정보처리방침<br />
				Copyrightⓒ2023 WEONUS All rights reserved.
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'PC_Main',
	components: {},
	computed: {},
	data() {
		return {};
	},
	created() {},
	methods: {},
};
</script>
